import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert, Spin, Switch
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Company/doview', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Company/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data,
                        type_react: data.type_react ? data.type_react : [],
                        honor_react: data.honor_react ? data.honor_react : [],
                        yq_id_react: data.yq_id_react ? data.yq_id_react : [],
                        regcapital_type_react: data.regcapital_type_react ? data.regcapital_type_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, {editorState: editorState, dwjj: editorState.toHTML()})
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, {[name]: fjlist})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {[name]: fjlist})
        this.setState({
            condition: data,
        })
    }

    onSelSearch = (name, value) => {
        let that = this
        fetch('/Contract/getItemByName', {
            method: "POST",
            body: JSON.stringify({
                name: value,
            })
        })
            .then(res => res.json())
            .then(data => {

                that.setState({
                    [name]: data.data
                })
            })

    }
    onSelSearch2 = (name, value) => {
        let that = this
        fetch('/Contract/getZaitiByName', {
            method: "POST",
            body: JSON.stringify({
                name: value,
            })
        })
            .then(res => res.json())
            .then(data => {

                that.setState({
                    [name]: data.data
                })
            })

    }

    getCompanyInfo = () => {
        let that = this
        let name = that.state.condition.name
        that.setState({
            getting: true
        })
        fetch('/Company/getCompanyInfo', {
            method: "POST",
            body: JSON.stringify({
                name,
            })
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    getting: false
                })
                if (data.status == 0) {
                    message.error(data.msg)
                    return
                }
                let condition = Object.assign({}, this.state.condition, {...data.data})
                this.setState({
                    condition
                })
            })
    }

    render() {

        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={this.mdchange.bind(this)}>新增企业</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Spin tip="正在获取中..." spinning={this.state.getting?this.state.getting:false} >
                        <Form
                            layout="vertical"
                            // labelCol={{ span: 3 }}
                            wrapperCol={{span: 24}}
                            autoComplete="off"
                        >
                            <Row gutter={[20, 0]} justify="start">
                                {/*<Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="所属园区"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.yq_id ? this.state.condition.yq_id : []}
                                        onChange={this.onSelChange.bind(this, 'yq_id')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.yq_id_react)}
                                    </Select>
                                </Form.Item>
                            </Col>*/}
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label={<Row justify={'space-between'} style={{width: '100%'}}>
                                            <span>企业名称</span>
                                            <a href={'javascript:void(0)'} onClick={() => {
                                                this.getCompanyInfo()
                                            }}>一键获取工商信息</a>
                                        </Row>}
                                        className={'fullwidth'}
                                        required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.name ? this.state.condition.name : null}
                                               onChange={this.onChange.bind(this, 'name')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={9}>
                                    <Form.Item
                                        label="统一社会信用代码"
                                        required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.creditCode ? this.state.condition.creditCode : null}
                                               onChange={this.onChange.bind(this, 'creditCode')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={3}>
                                    <Form.Item
                                        label="欠费提醒"
                                        // required={true}
                                    >
                                        <Switch checkedChildren="开启" unCheckedChildren="关闭" onChange={this.onSelChange.bind(this, 'remind')} checked={this.state.condition.remind ? this.state.condition.remind : false} />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="曾用名"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.aliasname ? this.state.condition.aliasname : null}
                                               onChange={this.onChange.bind(this, 'aliasname')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="成立时间"
                                        // required={true}
                                    >
                                        <DatePicker className="input" placeholder="请选择"
                                                    onChange={this.onTimeChange.bind(this, 'regtime')}
                                                    value={this.state.condition.regtime ? moment(this.state.condition.regtime) : null}
                                                    style={{width: "100%"}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="注册资本"
                                        // required={true}
                                    >
                                        <Input.Group compact>
                                            <Input placeholder="请输入"
                                                   style={{width: 'calc(100% - 120px)'}}
                                                   value={this.state.condition.regcapital ? this.state.condition.regcapital : null}
                                                   onChange={this.onChange.bind(this, 'regcapital')}/>
                                            <Select
                                                // mode="multiple"
                                                allowClear
                                                style={{width: 120}}
                                                placeholder="单位"
                                                value={this.state.condition.regcapital_type ? this.state.condition.regcapital_type : []}
                                                onChange={this.onSelChange.bind(this, 'regcapital_type')}
                                                maxTagCount="responsive"
                                                showSearch
                                                optionFilterProp="children"
                                            >
                                                {this.arrsel(this.state.regcapital_type_react)}
                                            </Select>
                                        </Input.Group>

                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="企业简称"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.qyjc ? this.state.condition.qyjc : null}
                                               onChange={this.onChange.bind(this, 'qyjc')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="法定代表人"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.corporation ? this.state.condition.corporation : null}
                                               onChange={this.onChange.bind(this, 'corporation')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="企业类型"
                                        required={true}
                                    >
                                        <Select
                                            // mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="请选择"
                                            value={this.state.condition.type ? this.state.condition.type : []}
                                            onChange={this.onSelChange.bind(this, 'type')}
                                            maxTagCount="responsive"
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {this.arrsel(this.state.type_react)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="企业行业"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.industry ? this.state.condition.industry : null}
                                               onChange={this.onChange.bind(this, 'industry')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="注册地址"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.reglocation ? this.state.condition.reglocation : null}
                                               onChange={this.onChange.bind(this, 'reglocation')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={24}>
                                    <Form.Item
                                        label="荣誉称号"
                                        // required={true}
                                    >
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="请选择"
                                            value={this.state.condition.honor ? this.state.condition.honor : []}
                                            onChange={this.onSelChange.bind(this, 'honor')}
                                            maxTagCount="responsive"
                                            showSearch
                                            optionFilterProp="children"
                                        >
                                            {this.arrsel(this.state.honor_react)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={24}>
                                    <Form.Item
                                        label="主营业务"
                                    >
                                        <TextArea placeholder="请输入"
                                                  value={this.state.condition.business ? this.state.condition.business : null}
                                                  onChange={this.onChange.bind(this, 'business')} rows={6}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={24}>
                                    <Form.Item
                                        label="企业附件"
                                    >
                                        <Row justify="space-between">
                                            <Space align="center">
                                                <Upload
                                                    showUploadList={false}
                                                    action="/Ajax/upload"
                                                    onChange={this.picChange.bind(this, 'fjlist')}
                                                    multiple={true}
                                                    data={{}}
                                                >
                                                    <Button icon={<UploadOutlined/>}>上传</Button>
                                                </Upload>
                                                <Space wrap>
                                                    {this.state.condition.fjlist ? this.state.condition.fjlist.map((item, index) =>
                                                        <div>
                                                            <a href={item.url} target="_blank">{item.name} </a>
                                                            <DeleteOutlined className="hongse"
                                                                            onClick={this.delpic.bind(this, index, 'fjlist')}/>
                                                        </div>) : null}

                                                </Space>
                                            </Space>
                                        </Row>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="招商负责人"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.zs_fzr ? this.state.condition.zs_fzr : null}
                                               onChange={this.onChange.bind(this, 'zs_fzr')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="招商部门"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.zs_bumen ? this.state.condition.zs_bumen : null}
                                               onChange={this.onChange.bind(this, 'zs_bumen')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="日常联系人"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.contacts ? this.state.condition.contacts : null}
                                               onChange={this.onChange.bind(this, 'contacts')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="日常联系人电话"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.phone ? this.state.condition.phone : null}
                                               onChange={this.onChange.bind(this, 'phone')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="紧急联系人"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.emcontacts ? this.state.condition.emcontacts : null}
                                               onChange={this.onChange.bind(this, 'emcontacts')}/>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="紧急联系人电话"
                                        // required={true}
                                    >
                                        <Input placeholder="请输入"
                                               value={this.state.condition.emphone ? this.state.condition.emphone : null}
                                               onChange={this.onChange.bind(this, 'emphone')}/>
                                    </Form.Item>
                                </Col>

                                <Col className="gutter-row" span={24}>
                                    <Form.Item>
                                        <Row justify={"center"}>
                                            <Button type='primary' onClick={this.sub.bind(this)}
                                                    loading={this.state.loading}>提交</Button>
                                        </Row>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </>
        )
    }
}

export default Edit
